(() => {
  if (!window.customElements || customElements.get('rnf-collection-flags')) return;
  const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)');
  const observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.target.isConnected) return;
      if (entry.isIntersecting && entry.intersectionRatio >= .15 && !document.hidden) entry.target.startWave();
      else if (entry.target.hasAttribute('data-waving')) entry.target.finishWave();
    });
  }, {threshold: .15}) : null;

  customElements.define('rnf-collection-flags', class extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-played') || reduced?.matches || document.hidden || !observer) {
        this.finishWave();
        return;
      }
      this.onEnd = event => {
        if (event.animationName === 'rnf-collection-flag-right') this.finishWave();
      };
      this.onCancel = () => this.finishWave();
      this.onVisibility = () => { if (document.hidden) this.finishWave(); };
      this.onReduced = () => { if (reduced.matches) this.finishWave(); };
      this.addEventListener('animationend', this.onEnd);
      this.addEventListener('animationcancel', this.onCancel);
      document.addEventListener('visibilitychange', this.onVisibility);
      reduced?.addEventListener?.('change', this.onReduced);
      observer.observe(this);
    }
    startWave() {
      if (this.hasAttribute('data-played') || this.hasAttribute('data-waving')) return;
      if (reduced?.matches || document.hidden) this.finishWave();
      else this.setAttribute('data-waving', '');
    }
    finishWave() {
      this.removeAttribute('data-waving');
      this.setAttribute('data-played', '');
      observer?.unobserve(this);
      this.removeEventListener('animationend', this.onEnd);
      this.removeEventListener('animationcancel', this.onCancel);
      document.removeEventListener('visibilitychange', this.onVisibility);
      reduced?.removeEventListener?.('change', this.onReduced);
    }
    disconnectedCallback() {
      if (this.hasAttribute('data-waving')) this.finishWave();
      else {
        observer?.unobserve(this);
        this.removeEventListener('animationend', this.onEnd);
        this.removeEventListener('animationcancel', this.onCancel);
        document.removeEventListener('visibilitychange', this.onVisibility);
        reduced?.removeEventListener?.('change', this.onReduced);
      }
    }
  });
})();
